import React from "react";
import Link from "components/common/Link";
import Image from "next/image";

const Banner = ({ webConfig, mobileView }) => {
  // Use the correct aspect ratio for the images
  // For desktop: 2928 / 1020
  // For mobile: Adjust these to match your actual mobile image ratio (e.g., 800x400)

  return (
    <div className="banner-container">
      <Link
        className={mobileView ? "mobile-banner" : "desktop-banner"}
        to="/landing"
        params={webConfig.lang !== "fa" ? { lang: webConfig.lang } : {}}
      >
        <Image
          src={
            mobileView
              ? webConfig.lang !== "fa"
                ? "/nextasset/images/search/banner-mobile-en.png"
                : "/nextasset/images/search/banner-mobile.png"
              : webConfig.lang !== "fa"
              ? "/nextasset/images/search/banner-en.png"
              : "/nextasset/images/search/banner.png"
          }
          alt="application-banner"
          // Keep the large numbers as "base" dimensions for aspect ratio
          width={mobileView ? 800 : 2928}
          height={mobileView ? 400 : 1020}
          className="banner-img"
          priority={true}
          sizes="100vw"
          style={{
            width: "100%",
            height: "auto",
          }}
        />
      </Link>
    </div>
  );
};

export default Banner;
